/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="results && results.scores"
    class="score-container svg-container dial-chart"
    tabindex="-1"
  >
    <svg
      viewBox="0 0 260 260"
      class="score"
    >
      <g>
        <circle
          cx="150"
          cy="130"
          r="120"
          class="score-bg"
        />
        <circle
          cx="150"
          cy="130"
          r="95"
          class="score-line"
        />
      </g>
      <g>
        <text
          transform="translate(150,130)"
          text-anchor="middle"
        >
          <tspan
            x="6"
            font-size="70"
            dy="20"
          >
            {{ scoreRounded }}
          </tspan>
          <tspan
            x="6"
            font-size="25"
            dy="35"
          >
            of {{ max }}
          </tspan>
        </text>
      </g>
      <g>
        <path
          :d="arcPath"
          class="score-arc"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import ChartHelper from '../utils/ChartHelper';

export default {
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'metric', 'speakerNum', 'tooltipId'],
  data() {
    return {
    };
  },
  computed: {
    max() {
      const ideals = this.recording.results.ideals[this.metric];
      return (ideals && ideals.range && ideals.range.max) ? ideals.range.max : 10;
    },
    scoreRounded () {
      return Math.round(this.results.scores[this.metric] * 10)/10;
    },
    arcPath() {
      return this._arcPath(150, 130, 80, 110, 90, 90 - this.score/this.max * 360);
    }
  },
  mounted() {
    this._addTooltip(this.tooltipId, this.recording, this.metric);
  },
};
</script>
